import { defaults, entities, getAPIMethod } from 'typed/api';
import { ExtractAction, entityActionSet, networkAction } from './utils';

export const
    companyAccessModules = {
        ...entityActionSet(defaults.CompanyAccessModule, {
            loadAll: networkAction('LOAD_ALL_COMPANY_ACCESS_MODULES', getAPIMethod('CompanyAccessModule', 'loadCurrentCompanyAccess'))
        }),
        enable: (entity: entities.CompanyAccessModule) =>
            networkAction('ENABLE_COMPANY_ACCESS_MODULE', { entity }, getAPIMethod<number>('CompanyAccessModule', 'enableAccessModule'), entity.ModuleID),
        disable: (moduleID: number) =>
            networkAction('DISABLE_COMPANY_ACCESS_MODULE', { moduleID }, getAPIMethod<number>('CompanyAccessModule', 'disableAccessModuleOfType'), moduleID)
    },

    loadCompanySubscriptionReport = () => networkAction('LOAD_COMPANY_SUBSCRIPTION_REPORT', getAPIMethod<entities.CompanySubscriptionReport>('CompanySubscriptionReportApi', 'load')),
    setCompanySubscriptionLevel = (subscriptionLevelID: number) =>
        networkAction('SET_COMPANY_SUBSCRIPTION_LEVEL', { subscriptionLevelID }, getAPIMethod('CompanySubscriptionReportApi', 'setCompanySubscriptionLevel'), subscriptionLevelID),
    disableCompanySubscriptionLevel = (subscriptionLevelID: number) =>
        networkAction('DISABLE_COMPANY_SUBSCRIPTION_LEVEL', { subscriptionLevelID }, getAPIMethod('CompanySubscriptionReportApi', 'disableCompanySubscriptionLevel'), subscriptionLevelID),
    editAllCompanyUserServiceLevels = (companyUserServiceLevels: entities.CompanyUserServiceLevelBase[]) =>
        networkAction('EDIT_ALL_COMPANY_USER_SERVICE_LEVELS', { companyUserServiceLevels }, getAPIMethod('CompanySubscriptionReportApi', 'editAllUserServiceLevels'), companyUserServiceLevels);

export type SubscriptionAction = ExtractAction<
| typeof companyAccessModules
| typeof loadCompanySubscriptionReport
| typeof setCompanySubscriptionLevel
| typeof disableCompanySubscriptionLevel
| typeof editAllCompanyUserServiceLevels
>;
